var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "43px",
    viewBox: "0 0 50 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Actions/check_circle_outline_black_24dp Copy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[MVP]-Tablet-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/Actions/check_circle_outline_black_24dp-Copy",
    transform: "translate(0.555555, 0.777778)",
    fill: "#FDB900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,42.2222225 L48.8888892,42.2222225 L24.4444446,0 L0,42.2222225 Z M26.6666668,35.5555558 L22.2222224,35.5555558 L22.2222224,31.1111113 L26.6666668,31.1111113 L26.6666668,35.5555558 Z M26.6666668,26.6666668 L22.2222224,26.6666668 L22.2222224,17.7777779 L26.6666668,17.7777779 L26.6666668,26.6666668 Z",
    id: "Shape"
  }))))));
}
export default SvgWarningIcon;